import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import clone from 'lodash/clone'
import { Button, Banner } from '@shopify/polaris'

import Phone from 'components/shared/Phone'
import { SHOPIFY_GRAY, fontSize } from 'components/styles'
import { getTemplateInfo, getTemplateByApp } from 'templates/templates'
import FinalSceneDesc from './shopifyUI/FinalSceneDesc'
import PlayIcon from 'assets/play_button.svg'
import { setShopifyBarTitle, initShopifyBarFinal, initShopifyBar } from 'controllers/shopifyBar'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  display: flex;
  align-items: center;
  ${fontSize}
  line-height: 1;
`
const PhoneContainer = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
`
const CenteredLayer = styled.div`
  position: absolute;
  top: 0;
  right: 10%;
  height: 80%;
  margin-top: 2em;
`
const EditorWrapper = styled.div`
  flex: 1.5;
  height: 100%;
`
const EditorContainer = styled.div`
  ${fontSize}
  margin-top: 2em;
  margin-right: 2em;
  max-width: 60em;
`
const PlayButtonContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);
  & > img {
    width: 15rem;
    height: 15rem;
    user-select: none;
    cursor: pointer;
  }
`
const StopButtonContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.9);
`
const DarkMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.73);
  display: ${props => props.iaStarted ? 'block' : 'none'};
`
const StopPreviewButtonContainer = styled.div`
  font-size: 2.6rem;
  position: absolute;
  top: 7rem;
  z-index: 12;
  display: flex;
  width: 100%;
  justify-content: center;
  & > button {
    width: 10em;
    justify-content: center;
  }
`
const NotificationContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  z-index: 11;
  top: 1em;
  display: flex;
  justify-content: center;
  font-size: 0.6em;
`

class ShopifyWizardFinalScene extends Component {

  constructor (props) {
    super(props)
    this.state = {
      template: getTemplateByApp(props.app),
      iaStarted: false
    }
    setShopifyBarTitle('Final review')
    initShopifyBarFinal(props.app.id)
  }

  onPlay = () => this.setState({iaStarted: true})
  onStop = () => this.setState({iaStarted: false})

  renderInstantApp (customizedSettings) {
    const { app, dispatch, location } = this.props
    const { template, iaStarted } = this.state
    console.log('renderInstantApp, location', location.sceneNum)
    const _InstantApp = getTemplateInfo(template.id).instantApp
    const wizardConf = template.shopifyWizardConf
    const scene = clone(wizardConf[location.sceneNum])
    if (iaStarted) {
      return (
        <_InstantApp
          appId={app.id}
          templateId={template.id}
          settings={customizedSettings}
          showcaseMode
          location={scene.location}
          dispatch={dispatch}
          onChange={() => null}
        >
          <StopButtonContainer>

          </StopButtonContainer>
        </_InstantApp>
      )
    } else {
      return (
        <div>
          <_InstantApp
            key={template.id}
            appId={app.id}
            templateId={template.id}
            settings={customizedSettings}
            editMode
            dispatch={dispatch}
            onChange={() => null}
          />
          <PlayButtonContainer>
            <img
              src={PlayIcon}
              onClick={this.onPlay}
            />
          </PlayButtonContainer>
        </div>
      )
    }
  }

  renderStopButton () {
    const { iaStarted } = this.state
    if (iaStarted) {
      return (
        <StopPreviewButtonContainer>
          <Button primary size='slim' onClick={this.onStop}>Done</Button>
        </StopPreviewButtonContainer>
      )
    }
  }

  renderNotification () {
    const { iaStarted } = this.state
    if (iaStarted) {
      return (
        <NotificationContainer>
          <Banner
            status='info'
            title='Use your cursor to tap and swipe through the preview'
          />
        </NotificationContainer>
      )
    }
  }

  goBack = () => {
    const { onBack } = this.props
    initShopifyBar()
    onBack()
  }

  render () {
    const { customizedSettings, goLive } = this.props
    const { iaStarted } = this.state
    return (
      <Wrapper iaStarted={iaStarted}>
        <PhoneContainer>
          <CenteredLayer>
            <Phone needOffset={false} wrapperRawStyle='z-index: 10'>
              {this.renderInstantApp(customizedSettings)}
            </Phone>
            {this.renderStopButton()}
          </CenteredLayer>
        </PhoneContainer>
        <EditorWrapper>
          <EditorContainer>
            <FinalSceneDesc onBack={this.goBack} goLive={goLive} />
          </EditorContainer>
        </EditorWrapper>
        <DarkMask iaStarted={iaStarted} />
        {this.renderNotification()}
      </Wrapper>
    )
  }

}


ShopifyWizardFinalScene.propTypes = {
  app: PropTypes.object.isRequired,
  customizedSettings: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
  goLive: PropTypes.func.isRequired
}

export default ShopifyWizardFinalScene
export {Wrapper, PhoneContainer, CenteredLayer, EditorWrapper, EditorContainer}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/ShopifyWizardFinalScene.js